export default "__VITE_ASSET__Bz0psjvw__"